import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AdminShell } from "./components/admin/AdminShell";
import { AdminHome } from "./routes/_index";
import { ReviewsPage } from "./routes/admin.reviews";
import { ReviewRequestsPage } from "./routes/admin.review-requests";
import { CampaignPage } from "./routes/admin.campaign";
import { WidgetsPage } from "./routes/admin.widgets";
import { SettingsPage } from "./routes/admin.settings";
import { AnalyticsPage } from "./routes/admin.analytics";
import { OperationsPage } from "./routes/admin.operations";
import { ReviewFormPage } from "./routes/review.$token";

export function AppRoot() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/review/:token" element={<ReviewFormPage />} />
        <Route path="/" element={<AdminShell />}>
          <Route index element={<AdminHome />} />
          <Route path="admin" element={<Navigate to="/" replace />} />
          <Route path="admin/reviews" element={<ReviewsPage />} />
          <Route path="admin/review-requests" element={<ReviewRequestsPage />} />
          <Route path="admin/whatsapp-campaigns" element={<CampaignPage channel="WhatsApp" />} />
          <Route path="admin/email-campaigns" element={<CampaignPage channel="Email" />} />
          <Route path="admin/widgets" element={<WidgetsPage />} />
          <Route path="admin/forms" element={<SettingsPage group="Forms" />} />
          <Route path="admin/discounts" element={<SettingsPage group="Discounts & Incentives" />} />
          <Route path="admin/referrals" element={<SettingsPage group="Referrals" />} />
          <Route path="admin/import-export" element={<OperationsPage mode="Import / Export" />} />
          <Route path="admin/ai-tools" element={<OperationsPage mode="AI Tools" />} />
          <Route path="admin/analytics" element={<AnalyticsPage />} />
          <Route path="admin/settings" element={<SettingsPage group="Settings" />} />
          <Route path="admin/integrations" element={<SettingsPage group="Integrations" />} />
          <Route path="admin/moderation" element={<ReviewsPage focus="moderation" />} />
          <Route path="admin/theme-setup" element={<WidgetsPage focus="theme" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
